import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { getPost } from '../posts';
import './Blog.css';

function BlogPost() {
  const { slug } = useParams();
  const post = getPost(slug);

  if (!post) {
    return (
      <main className="blog">
        <p>Post not found.</p>
        <Link to="/blog" className="blog-back">← Back to all posts</Link>
      </main>
    );
  }

  return (
    <main className="blog">
      <article className="blog-post">
        <div className="blog-post-meta">{post.date}</div>
        <div className="blog-post-body">
          <ReactMarkdown>{post.body}</ReactMarkdown>
        </div>
        <Link to="/blog" className="blog-back">← Back to all posts</Link>
      </article>
    </main>
  );
}

export default BlogPost;
